import React from 'react';
import { Container } from 'reactstrap';
import '../../pages/Category/Cemetery/Cemetery.scss';

function NoDataFound() {
    return (
        <div className='No_data_found_container'>
            <Container className='inner_container'>
                <p>There are no records to display</p>
            </Container>
        </div>
    )
}

export default NoDataFound